module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-65-min.69dda4e0.jpg";